// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1mJuL","containerItemsCenter":"Skeleton_containerItemsCenter__35J5s"};